import PropTypes from 'prop-types';
import React from 'react';
import Button from 'src/components/button';

class CollegeApplicationStatusQuestion extends React.Component {
  static propTypes = {
    college: PropTypes.object.isRequired,
    setCollegeAppStatus: PropTypes.func.isRequired,
    collegeApplicationQuestion: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    segmentEventLocation: PropTypes.string,
  };

  statusQuestion = (status) => {
    switch (status) {
      case 'planning-to-apply':
        return 'Do you plan to apply?';
      case 'applied':
        return 'Did you apply?';
      case 'accepted':
        return 'Do you plan to enroll?';
      case 'planning-to-enroll':
        return 'Do you plan to enroll?';
      case 'enrolled':
        return 'Did you enroll?';
      case 'not-interested':
        return 'Thanks for letting us know!';
      default:
        '';
    }
  };

  onClick = (status) => () => {
    const {setCollegeAppStatus, onClick, segmentEventLocation, college} = this.props;

    setCollegeAppStatus(college._id, status, segmentEventLocation);

    if (onClick) {
      onClick();
    }
  };

  render() {
    const {collegeApplicationQuestion} = this.props;

    return (
      <div className="college-application-status-question-container">
        <p className="college-application-status-question">
          {this.statusQuestion(collegeApplicationQuestion)}
        </p>
        <div className="college-application-status-question-buttons">
          <Button
            outline
            size="small"
            className="college-application-status-question-button"
            onClick={this.onClick(collegeApplicationQuestion)}
          >
            Yes
          </Button>
          <Button outline size="small" onClick={this.onClick('not-interested')}>
            No
          </Button>
        </div>
      </div>
    );
  }
}

export default CollegeApplicationStatusQuestion;
